// TaskSelect.jsx
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function TaskSelect({
  options,
  value,
  onChange,
  disabled,
  errorText,
  projectSelected,
  required
}) {
  return (
    <div className="form-input-expense" style={{ marginTop: 20 }}>
      <label className="form-input-label-expense">Task*</label>
      <Autocomplete
        options={options}
        getOptionLabel={(opt) => opt?.name ?? ''}
        value={value}
        onChange={onChange}
        disablePortal
        fullWidth
        disabled={disabled}
        className="mui-input"
        // Ensure equality by ID (string-safe)
        isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={projectSelected ? "Search task..." : "Select a project first"}
            error={!!errorText}
            helperText={errorText || ''}
            required={required}
          />
        )}
      />
    </div>
  );
}
